import React from 'react';
import "./wide_header.css";
import data from "../../../configs/wide-header/wide-header.json";

function WideHeader() {
  const buttonOpenPositionText = "View open positions";
  const insideUcText = "Inside UC";

  return (
    <div>
      <div className="wide-header-wrapper">
        <div className="wide-header">
          <div className="content">
            <div className="heading">{data["heading-statement"]}</div>
            <div className="sub-heading">{data["subheading-statement"]}</div>
            <div className="button">
              <a href="#recent-jobs" className="button-open-position">
                {buttonOpenPositionText}
              </a>
              <a href="#inside-uc" className="button-inside-uc">
                {insideUcText}
              </a>
            </div>
          </div>
          <div className="image">
            <img src={data["imageLink"]} alt="No image" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WideHeader;
